class LoginUsersController {
  static controller (ROLES, $scope, $state, $localStorage, LoginService, authService) {
    'ngInject';

    let EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    $scope.proceed = function (form) {
      if(!form.$valid){
        return;
      }
      
      // console.log('test', EMAIL_REGEXP.test(form.login.$modelValue));

      let loginIsEmail = EMAIL_REGEXP.test(form.login.$modelValue);
      if(loginIsEmail){
        $state.go('public.users.client.client-login', {email : form.login.$modelValue});
      } else {
        $state.go('public.users.instalator.instalator-login', {licenseId : form.login.$modelValue});
      }
    }
  };
}

export default LoginUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/login.users.controller.js